var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.195 14.817a.598.598 0 0 1 0-.884L11.39 10 7.195 6.067a.598.598 0 0 1 0-.884.698.698 0 0 1 .943 0l4.667 4.375c.26.244.26.64 0 .884l-4.667 4.375a.698.698 0 0 1-.943 0Z",
    fill: "#666"
  })));
};
export default SvgArrowRight;